import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="signup.existing-account" defaultMessage="Already have an account?" />
);
